/* eslint-disable @typescript-eslint/no-explicit-any */
const isObject = (item: unknown): boolean => {
  return item !== null && typeof item === 'object' && !Array.isArray(item);
};

const deepMerge = <T extends object>(
  target: T,
  ...sources: Partial<T>[]
): T => {
  try {
    const newTarget = Object.assign({}, target);

    if (sources.length === 0) return target;

    const source = sources.shift();

    if (isObject(newTarget) && isObject(source)) {
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          const sourceValue = source[key];
          if (isObject(sourceValue) && isObject(newTarget[key])) {
            newTarget[key] = deepMerge(
              newTarget[key] as any,
              sourceValue as any,
            );
          } else {
            (newTarget as any)[key] = sourceValue;
          }
        }
      }
    }

    return deepMerge(newTarget, ...sources);
  } catch (e) {
    console.error('Error during deep merge:', e);

    return target;
  }
};

export { deepMerge, isObject };
